import { loadState } from "@nextcloud/initial-state";
function isPublicShare() {
  return loadState("files_sharing", "isPublic", null) ?? document.querySelector(
    'input#isPublic[type="hidden"][name="isPublic"][value="1"]'
  ) !== null;
}
function getSharingToken() {
  return loadState("files_sharing", "sharingToken", null) ?? document.querySelector('input#sharingToken[type="hidden"]')?.value ?? null;
}
export {
  getSharingToken,
  isPublicShare
};
